/*
 * Further: header, navigation drawer and email signup.
 *
 * Ported from the inline scripts of the static site (index.html and
 * collage.html). Loaded by layout/further-landing.liquid and
 * layout/further-gallery.liquid.
 *
 * Listeners are delegated from the document, so they keep working when the
 * theme editor re-renders a section.
 */
(function () {
  'use strict';

  if (window.FurtherChrome) return;
  window.FurtherChrome = true;

  function byId(id) {
    return document.getElementById(id);
  }

  /* ================================
     Hamburger menu / slide-out drawer
     ================================ */
  function openMenu(keepFocus) {
    var hamburger = byId('hamburger');
    var navDrawer = byId('nav-drawer');
    var navOverlay = byId('nav-drawer-overlay');
    if (!hamburger || !navDrawer) return;

    hamburger.classList.add('active');
    hamburger.setAttribute('aria-expanded', 'true');
    navDrawer.removeAttribute('inert');
    navDrawer.classList.add('open');
    navDrawer.setAttribute('aria-hidden', 'false');
    if (navOverlay) navOverlay.classList.add('open');
    document.body.classList.add('menu-open');
    if (keepFocus === true) return;
    var firstLink = navDrawer.querySelector('a');
    if (firstLink) firstLink.focus();
  }

  function closeMenu(keepFocus) {
    var hamburger = byId('hamburger');
    var navDrawer = byId('nav-drawer');
    var navOverlay = byId('nav-drawer-overlay');
    if (!hamburger || !navDrawer) return;

    hamburger.classList.remove('active');
    hamburger.setAttribute('aria-expanded', 'false');
    navDrawer.classList.remove('open');
    navDrawer.setAttribute('aria-hidden', 'true');
    /* The closed drawer is off screen: keep keyboard focus out of it. */
    navDrawer.setAttribute('inert', '');
    if (navOverlay) navOverlay.classList.remove('open');
    document.body.classList.remove('menu-open');
    if (keepFocus === true) return;
    hamburger.focus();
  }

  function menuIsOpen() {
    var navDrawer = byId('nav-drawer');
    return !!navDrawer && navDrawer.classList.contains('open');
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    if (target.closest('#hamburger')) {
      if (menuIsOpen()) {
        closeMenu();
      } else {
        openMenu();
      }
      return;
    }

    if (target.closest('#nav-drawer-close') || target.closest('#nav-drawer-overlay')) {
      closeMenu();
      return;
    }

    if (target.closest('.nav-drawer-links a')) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!menuIsOpen()) return;

    if (e.key === 'Escape') {
      closeMenu();
      return;
    }

    if (e.key === 'Tab') {
      var navDrawer = byId('nav-drawer');
      var focusable = navDrawer.querySelectorAll('button:not([disabled]), a, input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  /* Theme editor: show the drawer while one of its links is being edited, and
     keep the page and a re-rendered header in step with each other. Focus is
     left alone so that typing in the editor's sidebar is not interrupted. */
  var reopenAfterRender = false;

  function holdsDrawer(element) {
    var navDrawer = byId('nav-drawer');
    return !!navDrawer && !!element && !!element.contains && element.contains(navDrawer);
  }

  document.addEventListener('shopify:block:select', function (e) {
    var navDrawer = byId('nav-drawer');
    if (navDrawer && e.target && navDrawer.contains(e.target) && !menuIsOpen()) openMenu(true);
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    if (holdsDrawer(e.target) && menuIsOpen()) closeMenu(true);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    /* The header is about to be re-rendered or removed: release the page,
       and show the drawer again if a fresh header follows. */
    if (!holdsDrawer(e.target) || !menuIsOpen()) return;
    closeMenu(true);
    reopenAfterRender = true;
    setTimeout(function () {
      reopenAfterRender = false;
    }, 3000);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!holdsDrawer(e.target)) return;
    if (reopenAfterRender || document.body.classList.contains('menu-open')) {
      reopenAfterRender = false;
      openMenu(true);
    }
  });

  /* ================================
     Header scroll behaviour (landing page)
     Shrinks after 100px, then fades and slides up near the end of the hero.
     Enabled by the "Fade out past the hero image" setting of the header section.
     ================================ */
  var fadeZone = window.innerHeight * 0.2;
  var fadeZoneWidth = window.innerWidth;

  /* Measured again when the window changes width (a phone turned sideways).
     Height-only changes are left alone: on phones the browser bar coming and
     going changes the height while scrolling. */
  window.addEventListener('resize', function () {
    if (window.innerWidth === fadeZoneWidth) return;
    fadeZoneWidth = window.innerWidth;
    fadeZone = window.innerHeight * 0.2;
  });

  window.addEventListener('scroll', function () {
    var header = document.querySelector('.further-root header[data-scroll-fade]');
    if (!header) return;

    header.classList.toggle('scrolled', window.scrollY > 100);

    var heroSection = document.querySelector('.further-root .hero');
    if (!heroSection) return;

    var heroBottom = heroSection.getBoundingClientRect().bottom;

    if (heroBottom <= 0) {
      header.classList.add('hidden');
      header.style.opacity = '0';
      header.style.transform = 'translateY(-100%)';
    } else if (heroBottom < fadeZone) {
      var progress = heroBottom / fadeZone;
      header.classList.remove('hidden');
      header.style.opacity = progress;
      header.style.transform = 'translateY(' + ((1 - progress) * -60) + 'px)';
    } else {
      header.classList.remove('hidden');
      header.style.opacity = '1';
      header.style.transform = 'translateY(0)';
    }
  });

  /* ================================
     Email signup
     The forms are standard Shopify customer (newsletter) forms.

     With Shopify's bot protection on (hCaptcha, the default), a signup has to
     carry the protection's answer or Shopify refuses it (HTTP 400). Shopify's
     own script sees to that: the first time a form is used it wires itself
     to the form (marking it data-hcaptcha-bound), and from then on it holds
     each submit back, fetches the answer and posts the form the normal way.

     So the rule here is to stay out of the way:
       1. If anything has already taken charge of a submit, do nothing. The
          form posts the normal way, the page comes back with the result, and
          the result is shown on the button with the page put back where it
          was (showPostedState).
       2. If nobody has, but bot protection is being set up on the page, ask
          Shopify to wire the form first (Shopify.captcha.protect, its
          documented call) and then post it the normal way.
       3. Only with no sign of bot protection at all is the form posted in
          the background and the result shown without leaving the page, like
          the static site did. If that answer cannot be read, back to 2.
     ================================ */
  var ERROR_LABEL = 'Error — try again';
  var BUSY_LABEL = 'Sending...';
  var CAPTCHA_FIELDS = '[name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"]';
  var HANDED_OVER = 'data-further-native';
  var SHOWING = 'data-further-showing';
  var MEMORY_KEY = 'further-signup';
  var submittedForm = null;
  var touchedForm = null;
  var leaving = false;

  function signupParts(form) {
    if (!form || !form.querySelector) return null;
    var emailInput = form.querySelector('[data-further-signup-email]');
    var btn = form.querySelector('[data-further-signup-button]');
    if (!emailInput || !btn) return null;
    return { email: emailInput, button: btn };
  }

  function setStatus(form, text) {
    var status = form.querySelector('[data-further-signup-status]');
    if (status) status.textContent = text;
  }

  function defaultLabelOf(btn) {
    var label = btn.getAttribute('data-default-label');
    if (label === null) {
      label = btn.textContent;
      btn.setAttribute('data-default-label', label);
    }
    return label;
  }

  /* options: clear (empty the field), duration (ms on the button),
     announceAfter (ms before screen readers are told; a page that has only
     just loaded does not announce text that was there from the start). */
  function showResult(form, emailInput, btn, message, options) {
    var defaultLabel = defaultLabelOf(btn);
    btn.textContent = message;
    btn.disabled = true;
    btn.setAttribute(SHOWING, '');
    if (options.announceAfter) {
      setTimeout(function () {
        setStatus(form, message);
      }, options.announceAfter);
    } else {
      setStatus(form, message);
    }
    if (options.clear && emailInput) emailInput.value = '';
    setTimeout(function () {
      btn.textContent = defaultLabel;
      btn.disabled = false;
      btn.removeAttribute(SHOWING);
    }, options.duration || 3000);
  }

  /* The form is on its way to Shopify the normal way. Only the label changes:
     the button stays usable so nothing the bot protection does is blocked.
     If nothing has come of it after a while, the label goes back. */
  function showBusy(btn, patience) {
    var defaultLabel = defaultLabelOf(btn);
    btn.textContent = BUSY_LABEL;
    setTimeout(function () {
      if (btn.textContent === BUSY_LABEL) btn.textContent = defaultLabel;
    }, patience || 8000);
  }

  /* What the form's own Liquid says about the last post (see the hidden
     markers at the end of each form). */
  function outcomeOf(form) {
    if (!form) return null;
    if (form.querySelector('[data-further-signup-posted]')) return { ok: true };
    var error = form.querySelector('[data-further-signup-error]');
    if (error) return { ok: false, message: (error.textContent || '').replace(/\s+/g, ' ').trim() };
    return null;
  }

  function labelFor(outcome) {
    if (outcome.ok) return 'Subscribed!';
    if (outcome.message && /taken|already/i.test(outcome.message)) return 'Already subscribed!';
    if (outcome.message && outcome.message.length <= 40) return outcome.message;
    return ERROR_LABEL;
  }

  /* ---- bot protection */

  /* Shopify's script has taken charge of this form (it marks the form once
     its own submit handling is in place). */
  function isWired(form) {
    return form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound');
  }

  /* An answer is already attached to the form. */
  function hasAnswer(form) {
    var fields = form.querySelectorAll(CAPTCHA_FIELDS);
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].value) return true;
    }
    return false;
  }

  /* Bot protection is being set up on this page: its answer field in the
     form, or its script on the page (Shopify loads it when a form is first
     used). */
  function protectionAround(form) {
    return !!(form.querySelector(CAPTCHA_FIELDS) || window.hcaptcha ||
      document.querySelector('script[src*="hcaptcha"], iframe[src*="hcaptcha"]'));
  }

  function shopifyCaptcha() {
    var captcha = window.Shopify && window.Shopify.captcha;
    return captcha && typeof captcha.protect === 'function' ? captcha : null;
  }

  function canPostInBackground() {
    return !!(window.fetch && window.FormData && window.URLSearchParams && window.DOMParser);
  }

  /* Have Shopify wire the form (if it is not yet), then carry on. protect()
     is Shopify's documented call for forms that are posted from a script; its
     callback runs once the protection is ready on the form. */
  function wireFirst(form, then) {
    var captcha = shopifyCaptcha();
    if (isWired(form) || !captcha) {
      then();
      return;
    }
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      then();
    };
    try {
      captcha.protect(form, go);
    } catch (err) {
      go();
      return;
    }
    /* The protection never arrived (blocked, offline): post anyway rather
       than leave the visitor waiting. */
    setTimeout(go, 10000);
  }

  /* ---- where the page was, for when it comes back after a normal post.
     Nothing personal is kept: which form, and the scroll position. */
  function rememberPlace(form) {
    try {
      window.sessionStorage.setItem(MEMORY_KEY, JSON.stringify({
        form: form.id,
        path: window.location.pathname,
        top: Math.round(form.getBoundingClientRect().top),
        scroll: Math.round(window.pageYOffset),
        at: Date.now()
      }));
    } catch (err) {
      /* no storage: the page comes back at the form's anchor instead */
    }
  }

  function forgetPlace() {
    try {
      window.sessionStorage.removeItem(MEMORY_KEY);
    } catch (err) {
      /* nothing to forget */
    }
  }

  function recallPlace() {
    try {
      var raw = window.sessionStorage.getItem(MEMORY_KEY);
      if (!raw) return null;
      window.sessionStorage.removeItem(MEMORY_KEY);
      var place = JSON.parse(raw);
      if (!place || place.path !== window.location.pathname) return null;
      if (Date.now() - place.at > 120000) return null;
      return place;
    } catch (err) {
      return null;
    }
  }

  /* ---- posting */
  function submitNatively(form) {
    wireFirst(form, function () {
      if (leaving) return;

      if (typeof form.requestSubmit === 'function') {
        /* Fires the submit event the way a click on the button does. On a
           wired form Shopify's handler takes it from there; the flag tells
           the listener below to stand aside. */
        form.setAttribute(HANDED_OVER, 'true');
        form.requestSubmit();
        form.removeAttribute(HANDED_OVER);
        return;
      }

      /* Older browsers. form.submit() fires no event; on a wired form it is
         Shopify's own version, which fetches the answer first. */
      submittedForm = form;
      rememberPlace(form);
      form.submit();
    });
  }

  function readOutcome(html, formId) {
    /* The response is the page re-rendered by Shopify. */
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return outcomeOf(formId ? doc.getElementById(formId) : null);
    } catch (err) {
      return null;
    }
  }

  function postInBackground(form, emailInput, btn) {
    var defaultLabel = defaultLabelOf(btn);
    btn.textContent = BUSY_LABEL;
    btn.disabled = true;
    /* the page stays: there is no place to come back to */
    submittedForm = null;
    touchedForm = null;
    forgetPlace();

    function handOver() {
      btn.disabled = false;
      btn.textContent = defaultLabel;
      showBusy(btn, 12000);
      submitNatively(form);
    }

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        var finalUrl = res.url || '';

        if (finalUrl.indexOf('/challenge') !== -1) {
          /* Shopify wants a bot check: only a normal form post can go through it. */
          handOver();
          return null;
        }

        return res.text().then(function (html) {
          var outcome = readOutcome(html, form.id);
          if (!outcome && res.ok && finalUrl.indexOf('customer_posted=true') !== -1) {
            outcome = { ok: true };
          }
          if (!outcome) {
            /* Neither a clear yes nor a clear no came back (a refusal, an
               interstitial page): post the form the normal way. */
            handOver();
            return;
          }
          showResult(form, emailInput, btn, labelFor(outcome), { clear: outcome.ok, duration: 3000 });
        });
      })
      .catch(function (err) {
        /* The page going away cuts a request short: that is not a failure. */
        if (leaving) return;
        console.error('Signup error:', err);
        showResult(form, emailInput, btn, ERROR_LABEL, { clear: false, duration: 3000 });
      });
  }

  /* Shopify starts wiring a form when one of its fields gets the focus. A
     button can be pressed without anything getting the focus (Safari does not
     focus a button that is clicked), so the same signal is passed on when a
     signup form is pressed or submitted while it is not wired. Whether to
     wire it remains Shopify's decision. */
  function nudge(form) {
    var parts = signupParts(form);
    if (!parts || isWired(form)) return;
    try {
      parts.email.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
    } catch (err) {
      /* no FocusEvent constructor: nothing to pass on */
    }
  }

  document.addEventListener('pointerdown', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (form) nudge(form);
  }, true);

  /* Note where the page is, whoever ends up posting the form and however:
     when the form is submitted (first in line, capture) and again when the
     page actually leaves. */
  document.addEventListener('focusin', function (e) {
    var form = e.target && e.target.form;
    if (form && signupParts(form)) touchedForm = form;
  });

  window.addEventListener('submit', function (e) {
    if (!signupParts(e.target)) return;
    submittedForm = e.target;
    rememberPlace(e.target);
    nudge(e.target);
  }, true);

  window.addEventListener('pagehide', function () {
    leaving = true;
    var form = submittedForm || touchedForm;
    if (form && document.documentElement.contains(form)) rememberPlace(form);
  });

  /* Last in line: on window, in the bubbling phase, and added only once the
     page has finished loading, so that it comes after anything else that
     handles the submit, including what is set up while the page loads. Until
     then a signup simply posts the normal way. */
  function onSubmit(e) {
    var form = e.target;
    var parts = signupParts(form);
    if (!parts) return;

    var handedOver = form.getAttribute(HANDED_OVER) === 'true';
    if (handedOver) form.removeAttribute(HANDED_OVER);

    /* 1. Somebody is already dealing with this submit: our own hand-over, a
          form that Shopify's bot protection has wired (it holds the submit
          back, then posts the form itself), an answer that is already
          attached, or any other handler that has held the form back. */
    if (handedOver || isWired(form) || hasAnswer(form)) {
      showBusy(parts.button);
      return;
    }
    if (e.defaultPrevented) return;

    /* 2. Nobody is, but bot protection is being set up on this page (or the
          browser cannot post in the background): have Shopify wire the form,
          then post it the normal way. Without Shopify's hook there is
          nothing to wire, and the form just posts. */
    if (protectionAround(form) || !canPostInBackground()) {
      showBusy(parts.button, 12000);
      if (shopifyCaptcha()) {
        e.preventDefault();
        submitNatively(form);
      }
      return;
    }

    /* 3. No sign of bot protection. */
    e.preventDefault();
    postInBackground(form, parts.email, parts.button);
  }

  function afterLoad(task, delay) {
    var run = function () {
      setTimeout(task, delay);
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run);
    }
  }

  afterLoad(function () {
    window.addEventListener('submit', onSubmit);
  }, 0);

  /* ---- after a normal form post: the page is back, with the result in the
     form's Liquid. Show it where the visitor was. */
  function jumpBy(distance) {
    /* At once, also where the stylesheet makes the page scroll smoothly. */
    var root = document.documentElement;
    var before = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollBy(0, distance);
    root.style.scrollBehavior = before;
  }

  function holdInPlace(distanceToGo) {
    /* Parts of the page are still arriving (product strip, images) and can
       push things around: keep the page where it should be for a few seconds,
       unless the visitor moves it. */
    var until = Date.now() + 5000;
    var released = false;
    var loaded = false;
    var lastScroll = null;
    var lastDistance = 0;
    var signals = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    var listening = { capture: true, passive: true };

    /* While the page loads the browser may scroll to the form's anchor on
       its own, more than once: only after that is a scroll taken to be the
       visitor's. */
    afterLoad(function () {
      loaded = true;
      lastScroll = null;
    }, 300);

    function release() {
      released = true;
    }

    function stop() {
      signals.forEach(function (type) {
        window.removeEventListener(type, release, listening);
      });
    }

    signals.forEach(function (type) {
      window.addEventListener(type, release, listening);
    });

    (function hold() {
      if (released || Date.now() > until) {
        stop();
        return;
      }
      var distance = distanceToGo();
      if (loaded && lastScroll !== null) {
        /* The page was scrolled by something other than this loop (scrollbar,
           assistive technology, ...) when it moved and the distance changed by
           the same amount. Content arriving above changes the distance without
           scrolling; a browser that keeps its own place scrolls without
           changing the distance. */
        var scrolled = window.pageYOffset - lastScroll;
        if (Math.abs(scrolled) > 2 && Math.abs(distance - lastDistance + scrolled) <= 3) {
          stop();
          return;
        }
      }
      if (Math.abs(distance) > 2) {
        jumpBy(distance);
        distance = distanceToGo();
      }
      lastScroll = window.pageYOffset;
      lastDistance = distance;
      setTimeout(hold, 150);
    })();
  }

  function dropAnchor(form) {
    /* The address still points at the form's anchor. While the page loads the
       browser keeps returning to it (scrolling there, taking the keyboard
       focus away), so let go of it straight away. */
    try {
      if (window.location.hash !== '#' + form.id) return;
      if (!window.history || !window.history.replaceState) return;
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    } catch (err) {
      /* cosmetic only */
    }
  }

  function tidyAddress() {
    /* Take the result out of the address bar, so reloading or sharing the
       page does not show it again. */
    try {
      if (!window.history || !window.history.replaceState || typeof window.URL !== 'function') return;
      var url = new URL(window.location.href);
      var drop = [];
      url.searchParams.forEach(function (value, key) {
        if (key === 'customer_posted' || key === 'form_type' || key === 'utf8' || key.indexOf('contact[') === 0) drop.push(key);
      });
      if (!drop.length) return;
      drop.forEach(function (key) {
        url.searchParams.delete(key);
      });
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* cosmetic only */
    }
  }

  function showPostedState() {
    var place = recallPlace();
    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    var forms = document.querySelectorAll('.further-root form');
    var navDrawer = byId('nav-drawer');
    var target = null;
    var outcome = null;
    var i;

    /* Which form was used: the address says so (Shopify keeps the form's
       anchor); failing that, the note taken when the page left. */
    var named = hash ? byId(hash) : null;
    var wanted = named && signupParts(named) ? hash : (place && place.form) || '';

    /* Shopify may report the result on every signup form of the page. Show it
       on the one that was used; failing that, on one in the page itself
       before the one in the menu. */
    for (i = 0; i < forms.length; i++) {
      var found = signupParts(forms[i]) ? outcomeOf(forms[i]) : null;
      if (!found) continue;
      var inMenu = !!navDrawer && navDrawer.contains(forms[i]);
      var better = !target || forms[i].id === wanted || (navDrawer && navDrawer.contains(target) && !inMenu);
      if (better) {
        target = forms[i];
        outcome = found;
      }
      if (forms[i].id === wanted) break;
    }

    if (!target && wanted && window.location.search.indexOf('customer_posted=true') !== -1) {
      /* Shopify says the post went through, without marking a form. */
      var used = byId(wanted);
      if (used && signupParts(used)) {
        target = used;
        outcome = { ok: true };
      }
    }
    if (!target) return;

    var parts = signupParts(target);

    /* A refused address is handed back to every signup form: keep it in the
       one that was used only. */
    for (i = 0; i < forms.length; i++) {
      var other = forms[i] === target ? null : signupParts(forms[i]);
      if (other && other.email.getAttribute('value')) other.email.value = '';
    }

    if (place && place.form !== target.id) place = null;
    dropAnchor(target);

    if (navDrawer && navDrawer.contains(target)) {
      /* The form is in the menu: put the page back and open the menu again. */
      if (place) {
        holdInPlace(function () {
          return place.scroll - window.pageYOffset;
        });
      }
      openMenu();
      afterLoad(function () {
        /* in case the browser took the focus back out while the page loaded */
        var firstLink = navDrawer.querySelector('a');
        if (menuIsOpen() && firstLink && !navDrawer.contains(document.activeElement)) firstLink.focus();
      }, 0);
    } else {
      holdInPlace(function () {
        var rect = target.getBoundingClientRect();
        var goal = place ? place.top : null;
        if (goal === null || goal < 0 || goal > window.innerHeight - 40) {
          goal = Math.max(0, (window.innerHeight - rect.height) / 2);
        }
        return rect.top - goal;
      });
    }

    showResult(target, parts.email, parts.button, labelFor(outcome), { clear: outcome.ok, duration: 6000, announceAfter: 1000 });

    /* Not straight away: anything that reads the address while the page
       loads (analytics counting signups, say) still gets to see it. */
    afterLoad(tidyAddress, 2000);
  }

  /* The page is shown: fresh, or back from the browser's page cache. Some
     browsers bring a button back disabled after a reload. */
  window.addEventListener('pageshow', function (e) {
    leaving = false;
    var buttons = document.querySelectorAll('.further-root [data-further-signup-button]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.hasAttribute(SHOWING) && !e.persisted) continue;
      var label = btn.getAttribute('data-default-label');
      if (e.persisted && label !== null) btn.textContent = label;
      btn.disabled = false;
      btn.removeAttribute(SHOWING);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showPostedState);
  } else {
    showPostedState();
  }
})();
